export default __webpack_public_path__ + "static/visual-app-builder-7e53fa82e46d46819f6fcf17f184b6a5.png";